import styled from 'styled-components';
const Icon = styled.div.withConfig({ displayName: "brc-sc-Icon", componentId: "brc-sc-78mfop" }) `
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  flex: 0 0 32px;
  margin: 4px 24px 0 0;

  > img {
    width: 100%;
    height: auto;
  }
`;
Icon.displayName = 'Icon';
export const IconContainer = Icon;
//# sourceMappingURL=icon-container.js.map